import { PageDataError } from 'src/shared/error';

export type HomepagePageUserData = {
	showV3: boolean;
	showHeroV3: boolean;
	showHowToV3: boolean;
	showRelease3: boolean;
};

export type HomepagePageUserDataErrorCode = 'homepage_v2_page_user_data_not_found';
export class HomepagePageUserDataError extends PageDataError<HomepagePageUserDataErrorCode> {}
